import styled from '@emotion/styled';
import RtlContainer from 'src/components/RtlContainer';
export const RootStyle = styled(RtlContainer)`
  overflow: hidden;
  display: flex;
  flex-grow: 1;
`;
export const Container = styled.div<{
  isWebview?: boolean;
}>`
  display: flex;
  flex-grow: 1;
  /* PWA 모드에서 노치(상단) 및 홈 인디케이터(하단) 영역 확보를 위한 safe-area 패딩 */
  ${({
  isWebview
}) => !isWebview && `
    padding-top: var(--sat);
    padding-bottom: var(--sab);
  `}
`;